import React, { Component, Fragment } from 'react';
import { MdAccessTime as TimeIcon } from 'react-icons/md';

import ShowingSelector from 'components/tenant_app/components/tenant_dashboard/todos/ShowingSelector';

import { formatMoney } from 'helpers/Formatter';
import { localize } from 'react-localize-redux';

class AmenityBookingForm extends Component {
  render() {
    const amenity = this.props.amenity;

    const style = {
      table_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
      },
    };

    return (
      <Fragment>
        {amenity &&
          amenity.showing_time && (
            <Fragment>
              <div className="row" style={style.table_header}>
                <div style={{ textAlign: 'center' }}>
                  <span style={{ textAlign: 'center' }}>
                    {this.props.translate('amenities.yourBookingDetails')}
                  </span>
                </div>
              </div>

              <div className="row" style={{ marginTop: '20px', fontSize: '15px' }}>
                <div className="col-xs-7" style={{ padding: 0 }}>
                  <p style={{ marginBottom: 0 }}>
                    <span>
                      <TimeIcon size={16} style={{ verticalAlign: 'text-bottom' }} />
                    </span>&nbsp;{amenity.showing_time} {this.props.translate('to')}
                  </p>
                  <p style={{ marginLeft: '16px' }}>
                    <span />&nbsp;{amenity.showing_end_time}
                  </p>
                </div>
                <div className="col-xs-5" style={{ padding: 0 }}>
                  {amenity.booking_fee > 0 && (
                    <p style={{ textAlign: 'right', marginRight: '24px', marginBottom: 0 }}>
                      {formatMoney(amenity.booking_fee)} to be charged
                    </p>
                  )}
                  <p style={{ textAlign: 'right', marginRight: '24px' }}>
                    <button
                      type="button"
                      className="link-button"
                      onClick={() => this.props.cancelAmenityBooking(amenity.booking_id)}
                    >
                      {this.props.translate('cancelBooking')}
                    </button>
                  </p>
                </div>
              </div>
            </Fragment>
          )}
        {amenity &&
          amenity.description && (
            <Fragment>
              <div className="row" style={style.table_header}>
                <div style={{ textAlign: 'center' }}>
                  <span style={{ textAlign: 'center' }}>
                    {this.props.translate('amenities.amenityDescription')}
                  </span>
                </div>
              </div>

              <div className="row" style={{ fontSize: '15px', marginTop: '15px' }}>
                <div className="col-xs-12" style={{ marginBottom: '5px' }}>
                  <p style={{ marginBottom: '0' }}> {amenity.description} </p>
                </div>
              </div>

              {amenity.amount_to_charge > 0 && (
                <div className="row">
                  <div className="col-xs-12">
                    <p style={{ fontSize: '11px', marginBottom: 0 }}>
                      **Note: to book this amenity, a charge of{' '}
                      {formatMoney(amenity.amount_to_charge)}/{amenity.time_unit.toLowerCase()} will
                      be collected on your selected booking start date.{' '}
                    </p>
                  </div>
                </div>
              )}
            </Fragment>
          )}

        <ShowingSelector
          amenityBookingDetails={amenity}
          submitForm={this.props.submitForm}
          toggleBookingDialog={this.props.toggleBookingDialog}
          fullScreen={this.props.fullScreen}
          onComplete={this.props.onComplete}
        />
      </Fragment>
    );
  }
}

export default localize()(AmenityBookingForm);
